import { SelectedPoolDscrMetrics } from 'features/drilldown/cashflows/gql/cashflowDataFragments';

import { gql, useQuery } from '@apollo/client';

import {
  GetSelectedPoolDscr,
  GetSelectedPoolDscrVariables,
} from './__generated__/getSelectedPoolDscr_gql';
export const GET_SELECTED_POOL_DSCR = gql`
  query GetSelectedPoolDscr($poolId: ID!) {
    user {
      id
      company {
        id
        pool(id: $poolId) {
          id
          performance_summary(filters: []) {
            ...SelectedPoolDscrMetrics
          }
        }
      }
    }
  }
  ${SelectedPoolDscrMetrics.performanceSummaryDscr}
`;

export const useSelectedPoolDscr = (poolId: string | null | undefined) => {
  return useQuery<GetSelectedPoolDscr, GetSelectedPoolDscrVariables>(GET_SELECTED_POOL_DSCR, {
    variables: { poolId: poolId! },
    skip: !poolId,
    fetchPolicy: 'cache-first',
  });
};
